const minRegistrationDate = new Date('2019-08-12T12:00:00.000Z')

type Values = {
  isMobile: boolean
  isLoggedIn: boolean
  registrationDate?: string
}

const checkAccessToMobileNavExperiment = ({ isMobile, isLoggedIn, registrationDate }: Values): boolean => {
  const isDateFit = registrationDate && new Date(registrationDate) > minRegistrationDate

  return Boolean(isMobile && isLoggedIn && isDateFit)
}


export default checkAccessToMobileNavExperiment
